import { ChatUpdateType } from "../enums/ChatEvents";
import { useSignalRConnection } from "./useSignalRConnection";

export enum ChatFinishedStatus {
  Completed = "Completed",
  Failed = "Failed",
  Cancelled = "Cancelled",
}

export interface ChatEventData {
  chatId: string;
  status?: ChatFinishedStatus;
  date: string;
  type: string;
}

export const useChatEventUpdates = (
  userId: string,
  callback: (type: ChatUpdateType, data: ChatEventData) => void,
): void => {
  useSignalRConnection({
    hubUrl: "/chatUpdatesHub",
    channelName: userId,
    logPrefix: " for All Chats",
    handleMessage: (name: string, data: string) => {
      const parsedData = JSON.parse(data);
      callback(name as ChatUpdateType, parsedData);
    },
    dependencies: [],
  });
};
